<template>  
<div class="col-12"> <!-- root element start -->

  <div class="card border-0">
    


      <div  class="card-body pt-0" v-if="detailsComp == 0">
        <div class="row">
          <div class="col-12 mt-4">
            <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
          </div>
        </div>
      </div>

      <div v-if="detailsComp == 1" class="card-body pt-0">

                <div class="row mb-3"> <!-- name and part number  -->
                  <div class="col-lg-12">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="inputGroupSelect01">Name</label>
                      </div>
                      <input type="text" class="form-control" v-model="name">
                    </div>
                  </div>
                </div>
                <div class="row mb-3"> <!-- name and part number  -->
                  <div class="col-lg-6">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="inputGroupSelect01">P/N</label>
                      </div>
                      <input type="text" class="form-control" v-model="part_number">
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="inputGroupSelect01">Status</label>
                      </div>
                      <select class="form-control" v-model="status">
                        <option value="0">Active</option>
                        <option value="1">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row mb-3"> <!-- description -->

                  <div class="col-lg-12">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="inputGroupSelect01">Description</label>
                      </div>
                      <textarea class="form-control" v-model="description"></textarea>
                    </div>
                  </div>
                </div>

                <div class="row mb-3"> <!-- price and initial item  -->

                  <div class="col-lg-3 mb-3 mb-md-0">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="inputGroupSelect01">Price</label>
                      </div>
                      <input type="text" class="form-control" v-model="price">
                    </div>
                  </div>
                  <div class="col-lg-3 mb-3 mb-md-0">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="inputGroupSelect01">Cost</label>
                      </div>
                      <input type="text" class="form-control" v-model="cost">
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="inputGroupSelect01">Initial</label>
                      </div>
                      <div class="form-check form-check-inline ml-3">
                        <input class="form-check-input" type="radio" v-model="initial_item" value="0">
                        <label class="form-check-label" for="inlineRadio1">Yes</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" v-model="initial_item" value="1">
                        <label class="form-check-label" for="inlineRadio2">No</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mb-3"> <!-- quantity allow and interval item  -->

                  <div class="col-lg-3 mb-3 mb-md-0">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="inputGroupSelect01">Qty</label>
                      </div>
                      <div class="form-check form-check-inline ml-3">
                        <input class="form-check-input" type="radio" v-model="qty_allow" value="0">
                        <label class="form-check-label" for="inlineRadio1">Yes</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" v-model="qty_allow" value="1">
                        <label class="form-check-label" for="inlineRadio2">No</label>
                      </div>
                    </div>
                  </div>

                  <div v-if="qty_allow == 0" class="col-lg-3">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="inputGroupSelect01">Interval</label>
                      </div>
                      <input type="number" min="0" class="form-control" v-model="interval_add">
                    </div>
                  </div>




                  <div v-if="qty_allow == 0" class="col-lg-3 mb-3 mb-md-0">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="inputGroupSelect01">Min</label>
                      </div>
                      <input type="number" min="0" class="form-control" v-model="min_allow">
                    </div>
                  </div>

                  <div v-if="qty_allow == 0" class="col-lg-3">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="inputGroupSelect01">Max</label>
                      </div>
                      <input type="number" min="0" class="form-control" v-model="max_allow">
                    </div>
                  </div>
                </div>

                <div class="row mb-3"> <!-- require and require of  -->

                  <div class="col-lg-6 mb-3 mb-md-0">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="inputGroupSelect01">Require</label>
                      </div>
                      <div class="form-check form-check-inline ml-3">
                        <input class="form-check-input" type="radio" v-model="require_allow" value="0">
                        <label class="form-check-label" for="inlineRadio1">Yes</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" v-model="require_allow" value="1">
                        <label class="form-check-label" for="inlineRadio2">No</label>
                      </div>
                    </div>
                  </div>

                  <div v-if="require_allow == 0" class="col-lg-6">
                    <div  class="input-group">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="inputGroupSelect01">Item</label>
                      </div>
                      <v-select 
                        v-model="require_of"
                        multiple
                        placeholder="Select Item"
                        label="part_number"
                        :options= "itemList"
                        :reduce="itemList => itemList.id"
                        class="p-0 bg-white style-chooser form-control">
                      </v-select>
                    </div>
                  </div>
                </div>

                <div class="row mb-3"> <!-- require and require of  -->

                  <div class="col-lg-6 mb-3 mb-md-0">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="inputGroupSelect01">Exclude</label>
                      </div>
                      <div class="form-check form-check-inline ml-3">
                        <input class="form-check-input" type="radio" v-model="exclude_allow" value="0">
                        <label class="form-check-label" for="inlineRadio1">Yes</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" v-model="exclude_allow" value="1">
                        <label class="form-check-label" for="inlineRadio2">No</label>
                      </div>
                    </div>
                  </div>

                  <div v-if="exclude_allow == 0" class="col-lg-6">
                    <div  class="input-group">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="inputGroupSelect01">Item</label>
                      </div>
                      <v-select 
                        v-model="exclude_of"
                        multiple
                        placeholder="Select Item"
                        label="part_number"
                        :options= "itemList"
                        :reduce="itemList => itemList.id"
                        class="p-0 bg-white style-chooser form-control">
                      </v-select>
                    </div>
                  </div>
                </div>
                

                <hr>
                <div class="row mb-3">

                  <div class="col-lg-12">
                    <button @click="submitForm" class="btn btn-success">Submit</button>
                    <button @click="resetForm" class="btn btn-primary">Reset</button>
                    <button @click="cancelForm" class="btn btn-danger">Cancel</button>
                  </div>

                </div>

            </div>
          </div>
        </div>
      </div>


</div><!--  end card -->


</div> <!-- root element end -->
</template>


<script>
import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../../stores/admin-item-single-main-store.js'


// import catMain from '../InstComponents/CategoryComponents/category-main.vue'


export default {

  data: function () {
    return { 
      name: '',
      part_number: '',
      status: '',
      description: '',
      price: '',
      cost: '',
      initial_item: '1',
      qty_allow: '1',
      interval_add: null,
      min_allow: null,
      max_allow: null,
      require_allow: '1',
      require_of: [],
      exclude_allow: '1',
      exclude_of: [],
    }
  },
  computed: {
    detailsList() { return this.$store.state.detailsList },
    detailsComp() { return this.$store.state.detailsComp },

    itemList() { return this.$store.state.itemList },
    itemComp() { return this.$store.state.itemComp },
  },
  watch: {
    
  },
  mounted() {
    this.onOpen();
  },
  methods: {
    changeRightView(name, prop1, prop2) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2 }); },
    onOpen() {
      var _this = this;
      _this.name = _this.detailsList.name;
      _this.part_number = _this.detailsList.part_number;
      _this.status = _this.detailsList.status;
      _this.description = _this.detailsList.description;
      _this.price = _this.detailsList.price;
      _this.cost = _this.detailsList.cost;
      _this.initial_item = _this.detailsList.initial_item;
      _this.qty_allow = _this.detailsList.qty_allow;
      _this.interval_add = _this.detailsList.interval_add;
      _this.min_allow = _this.detailsList.min_allow;
      _this.max_allow = _this.detailsList.max_allow;
      _this.require_allow = _this.detailsList.require_allow;
      _this.require_of = _this.detailsList.require_of;
      _this.exclude_allow = _this.detailsList.exclude_allow;
      _this.exclude_of = _this.detailsList.exclude_of;
    },
    cancelForm(){
      var _this = this;
      _this.$emit('onUComplete', ['item-detail-edit']);
    },
    resetForm(){
      var _this = this;
      _this.name = '';
      _this.part_number = '';
      _this.description = '';
      _this.price = '';
      _this.initial_item = '1';
      _this.qty_allow = '1';
      _this.interval_add = null;
      _this.min_allow = null;
      _this.max_allow = null;
      _this.require_allow = '1';
      _this.require_of = null;

    },
    validateForm() {
      var _this = this;
      var valErrors = [];

      // if(_this.name == '' || _this.name == null){ valErrors.push("A name is required!")  } 
      // if(_this.desc_name == '' || _this.desc_name == null){ valErrors.push("A descriptive name is required!")  } 
      // if(_this.part_number == '' || _this.part_number == null){ valErrors.push("A part number is required!")  } 
      // if((_this.description != '' && _this.description != null) && _this.description.length < 10 ){ valErrors.push("A description is not required, but if entered, a valid description of at least two characters is required!")  } 

      // if( valErrors.length > 0) {
      //   _this.errorDisplay(valErrors);
      //   return false;
      // } else {
      //   return true;
      // }
    },
    submitForm() {
      var _this = this;
      var a = _this.validateForm();
      if(a == false) {
        return false;
      }
      _this.$toastr.warning('Sending item edit information.', 'Please wait!')
      axios.post( '/admin/utility/item/edititem', {
        id: _this.detailsList.id,
        name: _this.name,
        part_number: _this.part_number,
        status: _this.status,
        description: _this.description,
        price: _this.price,
        cost: _this.cost,
        initial_item: _this.initial_item,
        qty_allow: _this.qty_allow,
        interval_add: _this.interval_add,
        min_allow: _this.min_allow,
        max_allow: _this.max_allow,
        require_allow: _this.require_allow,
        require_of: _this.require_of,
        exclude_allow: _this.exclude_allow,
        exclude_of: _this.exclude_of
      })
      .then(function(response){
        var msg = response.data.msg;
        _this.$toastr.remove()
        _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
        _this.$emit('onSComplete', ['item-detail-edit']);
      }) //end then
      .catch(function (error) {
        var errors = error.response.data.errors;
        _this.errorDisplay(errors);
      })
    },

    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    }
  },    
  components:{
    ScalingSquaresSpinner
  },
  filters: {

  }
}
</script>
